import { SuscriptionApiAdapter } from '../adapters/SuscriptionApiAdapter';
import { Filters, SuscriptionModel } from '../models/Suscription';

export interface Page {
  suscription: SuscriptionModel[];
  nextPage?: number;
  hasMore: boolean;
  total: number;
}

export class Service {
  constructor(private apiAdapter: SuscriptionApiAdapter) {}

  async getAllMovements(filters: Filters = {}): Promise<SuscriptionModel[]> {
    return this.apiAdapter.getAll();
  }

  async getPaginatedMovements(filters: Filters = {}): Promise<Page> {
    const { searchTerm, limit } = filters;

    // 🧠 Validaciones opcionales
    if (limit && limit > 100) {
      throw new Error('El límite no puede ser mayor a 100');
    }

    if (searchTerm && searchTerm.length < 2) {
      throw new Error(
        'El término de búsqueda debe tener al menos 2 caracteres'
      );
    }

    return this.apiAdapter.getSuscriptionPaginated();
  }

  async getPaginated(filters: Filters = {}): Promise<Page> {
    const { searchTerm, limit } = filters;

    if (limit && limit > 100) {
      throw new Error('El límite no puede ser mayor a 100');
    }

    if (searchTerm && searchTerm.length < 2) {
      throw new Error(
        'El término de búsqueda debe tener al menos 2 caracteres'
      );
    }

    return this.apiAdapter.getSuscriptionPaginated();
  }

  async getStripePortal(): Promise<string> {
    const response = await this.apiAdapter.getStripe();
    // El adapter devuelve { url: string }
    return response.url;
  }
}
